<template>
  <div
    class="log-card flex text-left gap-2 items-center bg-pitch-black pt-1 pl-1 pr-4 pb-4 mb-2 border-b-2 border-total-white-300"
    @click="handleCardClick"
  >
    <!-- Status Indicator (Shown only if log is unread) -->
    <div
      :class="['status-indicator self-start ml-2 mt-2', isNew ? 'bg-prime-golden' : '']"
    ></div>

    <!-- Log Details -->
    <div class="flex-1">
      <div class="flex justify-between items-center gap-1">
        <div class="flex items-center gap-1">
          <!-- Icon based on type -->
          <template v-if="type === 'email'">
            <img
              class="w-4 h-4 cursor-pointer mt-[-2.4px] mr-1"
              src="../assets/images/mail-icon.svg"
              alt="Email"
            />
          </template>
          <template v-else-if="type === 'call'">
            <img
              class="w-4 h-4 cursor-pointer mt-[-2.4px] mr-1"
              src="../assets/images/call-icon.svg"
              alt="Call"
            />
          </template>
          <template v-else-if="type === 'sms'">
            <img
              class="w-4 h-4 cursor-pointer mt-[-2.4px] mr-1"
              src="../assets/images/chat-icon.svg"
              alt="Text"
            />
          </template>
          <template v-else-if="type === 'calendar'">
            <img
              class="w-4 h-4 cursor-pointer mt-[-2.4px] mr-1"
              src="../assets/images/calendar-icon.svg"
              alt="Calendar"
            />
          </template>
          <template v-else-if="type === 'agent_system'">
            <img
                class="w-4 h-4 cursor-pointer mr-1 bg-grey-400"
                src="../assets/images/ai-icon.svg"
                alt="Ai Icon"
              />
          </template>
          <h3 class="log-card-title text-md font-semibold text-white">
            {{ title }}
          </h3>
        </div>
        <div class="flex flex-wrap space-x-2 items-center">
          <p class="text-xs !w-fit text-right text-gray-300">
            {{ date }}
          </p>
        </div>
      </div>
      <!-- Optional: Show extra details for email logs -->
      <p class="text-sm text-gray-300" v-if="type === 'email'">{{ truncatedUser }}</p>
      <p
        class="text-sm mt-1 text-gray-400 break-words overflow-hidden"
        :class="{ 'pt-2': type !== 'email' }"
      >
        {{ truncatedMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogCard",
  props: {
    title: { type: String, required: true },
    date: { type: String, required: true },
    message: { type: String, required: true },
    subject: { type: String, default: "Thread" },
    type: { type: String, required: true },
    id: { type: Number, required: true },
    isNew: { type: Boolean, default: false },
    thread_id: { type: Number, required: true },
  },
  computed: {
    truncatedTitle() {
      const maxLength = 22;
      return this.title.length > maxLength
        ? this.title.substring(0, maxLength) + "..."
        : this.title;
    },
    truncatedUser() {
      const maxLength = 30;
      return this.subject.length > maxLength
        ? this.subject.substring(0, maxLength) + "..."
        : this.subject;
    },
    truncatedMessage() {
      const maxLength = 50;
      // Strip HTML tags from the message
      const cleanMessage = this.message.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      
      if (cleanMessage.length <= maxLength) {
        return cleanMessage;
      }
      
      // Find the last space before the max length to avoid cutting words
      const truncated = cleanMessage.substring(0, maxLength);
      const lastSpaceIndex = truncated.lastIndexOf(' ');
      
      if (lastSpaceIndex > maxLength * 0.7) { // Only break at word boundary if it's not too far back
        return cleanMessage.substring(0, lastSpaceIndex) + "...";
      } else {
        return truncated + "...";
      }
    },
  },
  methods: {
    handleCardClick() {
      this.$emit("logClicked", {
        type: this.type,
        id: this.id,
        content: this.message,
        thread_id: this.thread_id,
      });
    },
  },
};
</script>

<style scoped>
.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.log-card h3,
.log-card p {
  overflow: hidden;
  text-overflow: ellipsis;
}
.log-card-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100vw - 80px);
}
@media (min-width: 768px) {
  .log-card-title {
    max-width: 400px;
  }
}
</style>
